<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row">
      <form-group :label="$t('brand.label')" :columns="6">
        <select v-model="filters.brand" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>

      <form-group :label="$t('status.label')" :columns="6" v-if="statuses.length">
        <select v-model="filters.status" class="form-select">
          <option :value=null>Todos</option>
          <option v-for="status in statuses" :key="status" :value="status">
            {{ $te(`${moduleIdentifier}.status.${status}.label`) ? $t(`${moduleIdentifier}.status.${status}.label`) : $t(`${status}.label`) }}
          </option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import Loader from '@/components/template/Loader'
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      brands: [],
      statuses: [],
      filters: {
        brand: null,
        status: null
      },
      loading: false
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      api.getBrands(this.module.type, this.module.identifier)
        .then(brands => { this.brands = brands })
        .catch(() => (this.brands = []))

      api.getProductStatuses('marketplace', 'renner')
        .then(statuses => { this.statuses = statuses })
        .catch(() => (this.statuses = []))
    },
    components: {
      FormGroup,
      Loader
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Renner.vue?18b9a27c